import React, {ReactNode} from "react";
import { View, StyleSheet, ViewStyle } from "react-native";
import { LinearGradient } from "expo-linear-gradient";

type GradientBorderBoxProps = {
  children: ReactNode;
  style?: ViewStyle | ViewStyle[];
};

export default function GradientBorderBox({children}:GradientBorderBoxProps) {
  // border: 2px solid var(linear-gradient(247deg, #FEDB8D 7.92%, #F3DBD3 52.68%, #CAEAEF 100.11%));
  return (
    <LinearGradient
      colors={["#CAEAEF", "#F3DBD3", "#FEDB8D"]}
      style={styles.gradientBorder}
    >
      <View style={styles.innerBox}>
        {children}
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  gradientBorder: {
    padding: 2,              // border thickness
    borderRadius: 6,
  },
  innerBox: {
    backgroundColor: "#fff",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 6.5,
    borderRadius: 6,
  },
});